require("./style.css");
import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";
import BreadCrumb from "../CreateCampaigns/Title/Title";
import { Row, Col, FullRow } from "../../framework/Grid";
import Checkbox from "material-ui/Checkbox";
import Dialog from "material-ui/Dialog";
import {
  pdfReportHeaderDataUri,
  downLoadCSVFunc,
  addPdfFooter,
} from "../../../utils/utility";

import isEmpty from "lodash/isEmpty";
import find from "lodash/find";
import isEqual from "lodash/isEqual";
import map from "lodash/map";
import Select from "react-select";

import moment from "moment-timezone/moment-timezone";

const pdfConverter = require("jspdf");
const html2canvas = require("html2canvas");

const styles = {
  subHead: {
    fontSize: "24px",
    height: "18px",
    lineHead: "18px",
    fontWeight: "bold",
    paddingLeft: "10px",
  },
  flextContainer: {
    display: "flex",
    borderBottom: "solid 1px #EEEFF2",
    height: "16px",
    lineHeight: "15px",
    paddingBottom: "30px",
    marginTop: "30px",
  },
  flexDataRow: {
    display: "flex",
    borderBottom: "solid 1px #EEEFF2",
    height: "20px",
    fontSize: "16px",
    lineHeight: "18px",
    paddingBottom: "35px",
    marginTop: "15px",
  },
  urlCell: {
    flex: "1 1",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    height: "25px",
  },
  clickDataCell: {
    flex: "0 0 120px",
    textAlign: "center",
  },
};

class TopLinksClick extends AcquireWebComponent {
  constructor(props) {
    super(props);
    let list = [];

    if (props.match && props.match.params) {
      if (props.campaignDetail) {
        let deployments;
        switch (props.match.params.channelType) {
          case "email":
          default:
            deployments = props.campaignDetail.emailDeployments;
            break;
          case "display":
            deployments = props.campaignDetail.displayDeployments;
        }
        map(deployments, dep => {
          if (
            parseInt(dep.id, 10) ===
            parseInt(props.match.params.channelCampaignId, 10)
          )
            map(dep.channelCampaigns, campaign => {
              list.push({ value: campaign.id, label: campaign.name });
            });
        });
        this.state = {
          groupCampaignId: props.match.params.id,
          channelCampaignList: list,
          height: 0,
          showDownloadDialog: false,
          onPdfReportDownload: false,
          disabledBtnDownload: false,
          onCsvReportDownload: false,
        };
        props.getCampaignTopLinkStats(
          props.match.params.id,
          props.match.params.segmentId,
          props.reportDateRange,
        );
        props.setChannelCampaignId({
          value: props.match.params.channelCampaignId,
        });
        props.setSegmentId(props.match.params.segmentId);
      } else {
        props.getCampaignById(props.match.params.id);
        props.setChannelCampaignId({
          value: props.match.params.channelCampaignId,
        });
        props.setSegmentId(props.match.params.segmentId);
        props.getCampaignTopLinkStats(
          props.match.params.id,
          props.match.params.segmentId,
          props.reportDateRange,
        );
        this.state = {
          groupCampaignId: undefined,
          channelCampaignList: [],
          height: 0,
          showDownloadDialog: false,
          onPdfReportDownload: false,
          disabledBtnDownload: false,
          onCsvReportDownload: false,
        };
      }
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  updateWindowDimensions() {
    this.setState({ height: window.innerHeight });
  }

  componentDidMount() {
    this.props.getCampaignById(this.props.match.params.id);
    this.props.setChannelCampaignId({
      value: this.props.match.params.channelCampaignId,
    });
    this.props.setSegmentId({ value: this.props.match.params.segmentId });
    this.props.getCampaignTopLinkStats(
      this.props.match.params.id,
      this.props.match.params.segmentId,
      this.props.reportDateRange,
      "",
    );
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.campaignDetail, this.props.campaignDetail)) {
      const list = [];
      let deployments;
      switch (this.props.match.params.channelType) {
        case "email":
        default:
          deployments = nextProps.campaignDetail.emailDeployments;
          break;
        case "display":
          deployments = nextProps.campaignDetail.displayDeployments;
      }
      map(deployments, dep => {
        if (
          parseInt(dep.id, 10) ===
          parseInt(this.props.match.params.channelCampaignId, 10)
        )
          map(dep.channelCampaigns, campaign => {
            list.push({ value: campaign.id, label: campaign.name });
          });
      });
      this.setState({
        channelCampaignList: list,
      });
      if (nextProps.segmentId) {
        this.props.getCampaignTopLinkStats(
          this.props.match.params.id,
          nextProps.segmentId,
          nextProps.reportDateRange,
          "",
        );
      } else {
        this.props.getCampaignTopLinkStats(
          this.props.match.params.id,
          this.props.match.params.segmentId,
          nextProps.reportDateRange,
          "",
        );
      }
    }
    if (nextProps.reportDateRange !== this.props.reportDateRange) {
      this.props.getCampaignTopLinkStats(
        this.props.match.params.id,
        this.props.match.params.segmentId,
        nextProps.reportDateRange,
        "",
      );
    }
    if (
      nextProps.match &&
      nextProps.match.params &&
      nextProps.match.params.segmentId !== this.props.match.params.segmentId
    ) {
      this.props.getCampaignTopLinkStats(
        this.props.match.params.id,
        nextProps.match.params.segmentId,
        nextProps.reportDateRange,
        "",
      );
    }

    if (nextProps.client_id !== this.props.client_id && this.props.client_id) {
      this.props.history.push("/campaigns");
    }
  }

  dateItem() {
    return [
      { value: "life-of-campaign", label: "Life of Campaign" },
      { value: "yesterday", label: "Yesterday" },
      { value: "today", label: "Today" },
      { value: "last-7-days", label: "Last 7 Days" },
      { value: "last-30-days", label: "Last 30 Days" },
    ];
  }

  reportDateFilter(dayRange) {
    let result = "";
    switch (dayRange) {
      case "yesterday":
        result = "Yesterday";
        break;
      case "today":
        result = "Today";
        break;
      case "last-7-days":
        result = "Last 7 Days";
        break;
      case "last-30-days":
        result = "Last 30 Days";
        break;
      case "life-of-campaign":
      default:
        result = "Life of Campaign";
        break;
    }
    return result;
  }

  cbPDFChange(e, isInputChecked) {
    const result = !this.refs.cbCSV.state.switched && !isInputChecked;
    this.setState({ disabledBtnDownload: result });
  }

  cbCSVChange(e, isInputChecked) {
    const result = !this.refs.cbPDF.state.switched && !isInputChecked;
    this.setState({ disabledBtnDownload: result });
  }

  downloadCsvReport() {
    this.setState({ onCsvReportDownload: true, showDownloadDialog: false });
    this.handleCsvDownload();
  }

  downloadPdfReport() {
    this.setState({ onPdfReportDownload: true, showDownloadDialog: false });
    this.handlePdfDownload();
  }

  handleCsvDownload() {
    const {
      clients,
      client_info,
      campaignDetail,
      reportDateRange,
      channelCampaignId,
    } = this.props;
    const { segmentId } = this.props.match.params;
    let client_name = client_info.name;
    let bu_name = "";
    if (client_info.parentClientId) {
      const parent_client = find(clients, c => {
        return c.id === client_info.parentClientId;
      });
      if (parent_client) {
        client_name = parent_client.name;
        bu_name = client_info.name;
      }
    }

    let channelType =
      this.props.match.params.channelType.charAt(0).toUpperCase() +
      this.props.match.params.channelType.slice(1);
    const channelCampaigns =
      channelType === "Email"
        ? campaignDetail.emailDeployments
        : campaignDetail.displayDeployments;
    const deployment =
      channelType.toLowerCase() === "display"
        ? campaignDetail.displayDeployments.filter(campaign => {
            return (
              parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10)
            );
          })[0]
        : campaignDetail.emailDeployments.filter(campaign => {
            return (
              parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10)
            );
          })[0];

    const channelPrix = channelType === "Display" ? "Google Ads" : channelType;
    const report_sub_title = `_${channelPrix}_Campaign_Report_`;
    const channelCampaignName = deployment ? deployment.name : "Aggregated";

    let csvFileName =
      channelType === "Email"
        ? campaignDetail.name + "_Email_"
        : campaignDetail.name + "_GoogleAds_";

    if (channelCampaignName !== "Aggregated") {
      if (segmentId === "aggregated") {
        csvFileName += "Segment_Aggregagted";
      } else {
        const emailCampaignDetail = find(
          deployment.channelCampaigns,
          campaign => {
            return parseInt(campaign.id, 10) === parseInt(segmentId, 10);
          },
        );
        csvFileName += emailCampaignDetail.name;
      }
    } else {
      csvFileName += "Deployment_Aggregate";
    }
    csvFileName += "_Top_Links_";
    let title_line = `AudienceAnywhere ${channelPrix} Segment Campaign Report,\r\n`;
    let date_line = "Today's Date," + moment().format("MM/DD/YY") + "\r\n";
    let client_line = "Client," + client_name + "\r\n";
    let business_unit_line = "Business Unit," + bu_name + "\r\n";
    let date_filter_line =
      "Date Filter," + this.reportDateFilter(reportDateRange) + "\r\n";
    const split_line = ",\r\n";
    const emailCampaignDetail = find(deployment.channelCampaigns, campaign => {
      return parseInt(campaign.id, 10) === parseInt(segmentId, 10);
    });
    let campaign_group_name_line =
      "Campaign Group Name," + campaignDetail.name + ",,,,,,,\r\n";

    const email_campaign_name =
      channelType === "Email"
        ? "Email Segment Name," + emailCampaignDetail.name + ",,,,,,,\r\n"
        : "Google Ads Segment Name," + emailCampaignDetail.name + ",,,,,,,\r\n";
    const email_campaign_status =
      "Status," + emailCampaignDetail.status + ",,,,,,,\r\n";
    const email_campaign_start_date =
      "Start Date," +
      moment(emailCampaignDetail.startDate).format("MM/DD/YYYY") +
      ",,,,,,,\r\n";
    const email_campaign_end_date = emailCampaignDetail.endDate
      ? "End Date," +
        moment(emailCampaignDetail.endDate).format("MM/DD/YYYY") +
        ",,,,,,,\r\n"
      : "End Date,,,,,,,,\r\n";
    if (channelType === "Email")
      campaign_group_name_line +=
        "Email Deployment Name," + channelCampaignName + ",,,,,,,\r\n";
    else
      campaign_group_name_line +=
        "Google Ads Deployment Name," + channelCampaignName + ",,,,,,,\r\n";

    campaign_group_name_line += email_campaign_name;
    campaign_group_name_line += email_campaign_status;
    campaign_group_name_line += email_campaign_start_date;
    campaign_group_name_line += email_campaign_end_date;
    campaign_group_name_line += ",,,,,,,,\r\n";

    const top_links_title = ",\r\n,\r\nTop Links Clicked,\r\n";
    //const top_links_table_head = 'Link,Pct. Clicked\r\n';
    const top_links_table_head = "Link,Total Clicks, Unique Clicks\r\n";
    let top_links_table_rows = "";
    map(this.props.topLinkStats, stat => {
      top_links_table_rows +=
        stat.linkurl + "," + stat.clicks + "," + stat.uniqueclicks + "\r\n";
      //stat.clickrate.toLocaleString("en-US",{ style:"percent", maximumFractionDigits: 2 }) + "\r\n";
    });
    let resultString =
      title_line +
      date_line +
      client_line +
      business_unit_line +
      date_filter_line +
      split_line +
      campaign_group_name_line +
      top_links_title +
      top_links_table_head +
      top_links_table_rows;

    csvFileName += moment().format("YYYYMMDD");
    csvFileName = csvFileName.replace(new RegExp(" ", "g"), "_");
    downLoadCSVFunc(resultString, csvFileName);
    setTimeout(
      function() {
        this.setState({ onCsvReportDownload: false });
      }.bind(this),
      2000,
    );
  }

  handlePdfDownload() {
    const {
      clients,
      client_info,
      campaignDetail,
      channelCampaignId,
      reportDateRange,
    } = this.props;
    const { segmentId } = this.props.match.params;
    let client_name = client_info.name;
    let bu_name = "";
    if (client_info.parentClientId) {
      const parent_client = find(clients, c => {
        return parseInt(c.id, 10) === parseInt(client_info.parentClientId, 10);
      });
      if (parent_client) {
        client_name = parent_client.name;
        bu_name = client_info.name;
      }
    }

    const channelType =
      this.props.match.params.channelType.charAt(0).toUpperCase() +
      this.props.match.params.channelType.slice(1);

    const deployment =
      channelCampaignId === "aggregated"
        ? null
        : channelType.toLowerCase() === "display"
        ? campaignDetail.displayDeployments.filter(campaign => {
            return (
              parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10)
            );
          })[0]
        : campaignDetail.emailDeployments.filter(campaign => {
            return (
              parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10)
            );
          })[0];
    const channelCampaignName =
      channelCampaignId === "aggregated" ? "Aggregated" : deployment.name;

    let pdfFileName =
      channelType === "Email"
        ? campaignDetail.name + "_Email_"
        : campaignDetail.name + "_GoogleAds_";

    if (channelCampaignName !== "Aggregated") {
      if (segmentId === "aggregated") {
        pdfFileName += "Segment_Aggregagted";
      } else {
        const emailCampaignDetail = find(
          deployment.channelCampaigns,
          campaign => {
            return parseInt(campaign.id, 10) === parseInt(segmentId, 10);
          },
        );
        pdfFileName += emailCampaignDetail.name;
      }
    } else {
      pdfFileName += "Deployment_Aggregate";
    }
    pdfFileName += "_Top_Links_";
    const pdf = new pdfConverter("p", "mm", "a4");
    pdf.setFont("Helvetica");
    pdf.setFontType("normal");
    pdf.setFontSize(9);
    const pageWidth = 186;

    const el_campaign_list = document.getElementsByClassName(
      "top-links-list-container",
    )[0];
    const el_campaign_detail = document.getElementsByClassName(
      "email-campaign-detail-container",
    )[0];
    const el_select_control = document.getElementsByClassName(
      "Select-control",
    )[1];
    const el_select_arrow = document.getElementsByClassName("Select-arrow")[1];
    const el_top_links = document.getElementsByClassName("top-link-url");
    map(el_top_links, link => {
      link.style["word-break"] = "break-all";
      link.style["white-space"] = "unset";
    });

    let canvasList = null;
    let isCanvasListReady = false;
    let canvasDetail = null;
    let isCanvasDetailReady = false;
    const oriWidth = el_campaign_list.offsetWidth;
    document.getElementsByClassName(
      "nav-btn-download-report",
    )[0].style.display = "none";

    el_campaign_list.style.width = "1024px";
    el_campaign_detail.style.width = "1024px";
    el_select_control.style["border"] = "solid 0px #D3D3D3";
    el_select_control.style["margin-left"] = "-10px";
    el_select_arrow.style["border-style"] = "none";

    setTimeout(function() {
      html2canvas(el_campaign_list, { logging: false }).then(function(canvas) {
        canvasList = canvas;
        isCanvasListReady = true;
        el_campaign_list.style.width = oriWidth + "px";
      });
    }, 100);

    setTimeout(function() {
      html2canvas(el_campaign_detail, { logging: false }).then(function(
        canvas,
      ) {
        canvasDetail = canvas;
        isCanvasDetailReady = true;
        el_campaign_detail.style.width = oriWidth + "px";
        el_select_control.style.border = "solid 1px #D3D3D3";
        el_select_control.style["margin-left"] = "0px";
        el_select_arrow.style["border-style"] = "solid";

        map(el_top_links, link => {
          link.style["white-space"] = "nowrap";
        });
      });
    }, 100);

    let top = 37;
    const left = 12;
    let intervalId = setInterval(
      function() {
        if (isCanvasListReady === false || isCanvasDetailReady === false) {
          console.log("PDF Generating...");
        } else {
          clearInterval(intervalId);
          setTimeout(
            function() {
              pdf.setFillColor(127, 127, 127);
              pdf.rect(0, 15, 210, 10, "F");

              pdf.setTextColor(0, 0, 0);
              pdf.setFontSize(9);
              pdf.setFontType("bold");
              pdf.addImage(pdfReportHeaderDataUri(), "PNG", 10.5, 3, 60, 0);
              pdf.text(
                198,
                8,
                moment().format("MMMM DD, YYYY"),
                null,
                null,
                "right",
              );

              pdf.setTextColor(255, 255, 255);
              pdf.setFontType("bold");
              pdf.text(12, 21, "Client:");
              //const lenClientName = getTextSize(client_name.trim(), 'helvetica')
              pdf.setFontType("normal");
              pdf.text(26, 21, client_name ? client_name.trim() : "");
              //cm to inches
              let start = 90; //46 + lenClientName.width * 0.3937 + 0.4
              if (!isEmpty(bu_name)) {
                pdf.setFontType("bold");
                pdf.text(start, 21, "Business Unit:");
                start += 26.5;
                pdf.setFontType("normal");
                pdf.text(start, 21, bu_name ? bu_name.trim() : "");
              }
              pdf.setFillColor(255);
              start = 12;
              pdf.setTextColor(0, 0, 0);
              pdf.setFontSize(10);
              const navText =
                channelType === "Email"
                  ? "Campaigns  >  " +
                    campaignDetail.name +
                    "  >   " +
                    "Email  " +
                    " > Email Top Links Clicked"
                  : "Campaigns  >  " +
                    campaignDetail.name +
                    "  >   " +
                    "Google Ads " +
                    " > Google Ads Top Links Clicked";
              pdf.text(12, 34, navText);

              top = 50;
              pdf.addImage(
                canvasDetail.toDataURL(),
                "PNG",
                left,
                top,
                pageWidth,
                0,
              );
              top += (canvasDetail.height * pageWidth) / canvasDetail.width + 4;
              pdf.addImage(
                canvasList.toDataURL(),
                "PNG",
                left,
                top,
                pageWidth,
                0,
              );
              top += (canvasList.height * pageWidth) / canvasList.width + 4;
              addPdfFooter(pdf);

              document.getElementsByClassName(
                "nav-btn-download-report",
              )[0].style.display = "block";

              pdfFileName =
                pdfFileName.replace(new RegExp(" ", "g"), "_") +
                moment().format("YYYYMMDD") +
                ".pdf";
              pdf.save(pdfFileName);
              this.setState({ onPdfReportDownload: false });
            }.bind(this),
            100,
          );
        }
      }.bind(this),
      50,
    );
  }

  handleDownload(e) {
    e.preventDefault();

    if (this.refs.cbPDF.state.switched) {
      this.downloadPdfReport();
    }

    if (this.refs.cbCSV.state.switched) {
      this.downloadCsvReport();
    }
  }

  onChangeSegment(data) {
    this.props.setSegmentId(data);
    this.props.history.push(
      `/campaigns/report/${this.props.match.params.id}/email/${this.props.match.params.channelCampaignId}/${data.value}/top-links-click`,
    );
  }

  render() {
    const {
      channelCampaignId,
      campaignDetail,
      reportDateRange,
      topLinkStats,
      setReportDateRange,
      loadingTopLinkStats,
    } = this.props;
    const crumbs = [];
    const crumbsLink = [];
    let channelCampaigns;
    //let channelCampaignTitle = "";
    let showUniqClicks = true;
    let deploymentName = "";
    const selectSegment = this.props.match
      ? find(this.state.channelCampaignList, segment => {
          return segment.value == this.props.match.params.segmentId;
        })
      : undefined;

    switch (this.props.match.params.channelType) {
      case "email":
      default:
        channelCampaigns = campaignDetail
          ? campaignDetail.emailDeployments
          : null;
        //channelCampaignTitle = "Email Segment Name";
        showUniqClicks = true;
        break;
      case "display":
        channelCampaigns = campaignDetail
          ? campaignDetail.displayDeployments
          : null;
        //channelCampaignTitle = "Google Ads Campaign";
        showUniqClicks = false;
        break;
    }
    if (channelCampaigns) {
      crumbs.push(campaignDetail.name);
      crumbsLink.push(`/campaigns/report/${campaignDetail.id}`);
      if (
        channelCampaignId === undefined ||
        channelCampaignId === "aggregated"
      ) {
        crumbs.push("Email Deployment: Aggregate");
      } else {
        map(channelCampaigns, campaign => {
          if (parseInt(campaign.id, 10) === parseInt(channelCampaignId, 10)) {
            switch (this.props.match.params.channelType) {
              case "email":
                crumbs.push("Email ");
                deploymentName = campaignDetail.name;
                crumbsLink.push(
                  `/campaigns/report/${campaignDetail.id}/email/${this.props.match.params.channelCampaignId}`,
                );
                crumbs.push("Email Top Links Clicked");
                break;
              case "display":
              default:
                crumbs.push("Google Ads ");
                deploymentName = campaignDetail.name;
                crumbsLink.push(
                  `/campaigns/report/${campaignDetail.id}/display/${this.props.match.params.channelCampaignId}`,
                );
                crumbs.push("Google Ads Top Links Clicked");
                break;
            }
          }
        });
      }
    }

    return (
      <div
        className="campaign-report-container"
        style={{ background: "#FFFFFF", fontFamily: "Arial" }}
      >
        <BreadCrumb
          crumbs={crumbs}
          crumbsLink={crumbsLink}
          linkName="Campaigns"
          showDownloadBtn={true}
          handleDownload={() => {
            this.setState({ showDownloadDialog: true });
          }}
          selected_client={this.props.client_id}
        />
        <FullRow className="light-grey-border mt-20 no-margin-left no-margin-right no-padding-left no-padding-top mb-20 pr-10 email-campaign-detail-container">
          <h3
            className="pl-10 mt-10"
            style={{ fontSize: "24px", fontWeight: "bold" }}
          >
            {showUniqClicks ? "Email Selection" : "Google Ads Selection"}
          </h3>
          <table style={{ width: "98%", marginLeft: "10px" }}>
            <thead style={styles.tableHeaderStyle}>
              <tr style={{ height: "42px" }}>
                <th style={{ width: "40%", paddingLeft: "20px" }}>
                  <strong>
                    {showUniqClicks
                      ? "Email Deployment"
                      : "Google Ads Deployment"}
                  </strong>
                </th>
                <th>
                  <strong>
                    {showUniqClicks ? "Email Segment" : "Google Ads Segment"}
                  </strong>
                </th>
                <th style={{ paddingRight: "20px", width: "200px" }}>
                  <strong>Date</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ height: "60px" }}>
                <td
                  style={{
                    width: "40%",
                    paddingLeft: "20px",
                    paddingRight: "50px",
                    wordBreak: "break-word",
                  }}
                >
                  {deploymentName}
                </td>
                <td
                  style={{
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                    paddingRight: "20px",
                  }}
                >
                  <div>{selectSegment ? selectSegment.label : ""}</div>
                </td>
                <td style={{ paddingRight: "20px", minWidth: "200px" }}>
                  <Select
                    className="top-link-report-date-selector left-10 z-index-199"
                    value={reportDateRange}
                    clearable={false}
                    searchable={false}
                    options={this.dateItem()}
                    placeholder={"Select Day"}
                    onChange={setReportDateRange.bind(this)}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </FullRow>
        <FullRow
          className="light-grey-border no-margin-left no-margin-right pr-10 pt-10 no-padding-left pb-20 top-links-list-container"
          style={{
            /*minHeight: this.state.height ? this.state.height - 200 : 250,*/ fontSize:
              "16px",
          }}
        >
          <div style={styles.subHead}>
            {showUniqClicks ? "Email" : "Google Ads"} Top Links Clicked
          </div>
          <table
            style={{
              width: "98%",
              marginLeft: "10px",
              marginTop: "40px",
              tableLayout: "fixed",
            }}
          >
            <thead style={styles.tableHeaderStyle}>
              <tr style={{ height: "42px" }}>
                <th style={{ width: "72%", paddingLeft: "20px" }}>
                  <strong>Top Links</strong>
                </th>
                <th>
                  <strong>Total Clicks</strong>
                </th>
                <th style={{ width: "120px", paddingRight: "20px" }}>
                  <strong>Unique Clicks</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              {map(topLinkStats, stat => {
                return (
                  <tr key={"row-" + stat.linkurl} style={{ height: "42px" }}>
                    <td
                      style={{
                        width: "72%",
                        paddingLeft: "20px",
                        paddingRight: "50px",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        dispaly: "block",
                      }}
                      className="top-link-url"
                    >
                      <a href={stat.linkurl} target="_blank">
                        {stat.linkurl}
                      </a>
                    </td>
                    <td>{stat.clicks}</td>
                    <td
                      style={{
                        width: "117px",
                        paddingRight: "20px",
                        textAlign: "right",
                      }}
                    >
                      {stat.uniqueclicks}
                    </td>
                  </tr>
                );
              })}
              {isEmpty(topLinkStats) && loadingTopLinkStats !== true && (
                <tr>
                  <td colSpan="3">
                    <div
                      className="pt-20 pb-20"
                      style={{
                        textAlign: "center",
                        fontSize: "2em",
                        color: "#CCCCCC",
                      }}
                    >
                      No Data
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </FullRow>

        <Dialog
          open={this.state.onCsvReportDownload}
          style={{ top: "-1.8em" }}
          modal={true}
          contentStyle={{ width: "500px" }}
          overlayStyle={{ opacity: 0.9, backgroundColor: "#666666" }}
        >
          <Row className="mt-20">
            <Col
              offsetXs="1"
              offsetSm="1"
              offsetMd="1"
              offsetLg="1"
              xs="7"
              sm="7"
              md="7"
              lg="7"
              className="text-right"
            >
              <div>{"Downloading, please wait..."}</div>
            </Col>
            <Col xs="1" sm="1" md="1" lg="1">
              <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
            </Col>
          </Row>
        </Dialog>
        <Dialog
          open={this.state.onPdfReportDownload}
          style={{ top: "-1.8em" }}
          modal={true}
          contentStyle={{ width: "500px" }}
          overlayStyle={{ opacity: 0.9, backgroundColor: "#666666" }}
        >
          <Row className="mt-20">
            <Col
              offsetXs="1"
              offsetSm="1"
              offsetMd="1"
              offsetLg="1"
              xs="7"
              sm="7"
              md="7"
              lg="7"
              className="text-right"
            >
              <div>{"Downloading, please wait..."}</div>
            </Col>
            <Col xs="1" sm="1" md="1" lg="1">
              <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
            </Col>
          </Row>
        </Dialog>
        <Dialog
          open={this.state.showDownloadDialog}
          style={{ top: "-1.8em" }}
          modal={true}
          contentStyle={{ width: "440px" }}
        >
          <FullRow
            className="no-margin-top no-padding"
            style={{ fontSize: "16px", color: "#000" }}
          >
            <strong>Choose the type of file you would like to download</strong>
          </FullRow>
          <FullRow
            className="no-padding-top no-padding-right no-padding-bottom no-margin-bottom"
            style={{ paddingLeft: "150px" }}
          >
            <Checkbox
              iconStyle={{ fill: "#47A1AB", marginRight: "10px" }}
              label={"PDF File"}
              labelStyle={{ fontSize: "13px" }}
              defaultChecked={false}
              ref="cbPDF"
              onCheck={(e, isInputChecked) =>
                this.cbPDFChange(e, isInputChecked)
              }
            />
          </FullRow>
          <FullRow
            className="no-padding-top no-padding-right no-padding-bottom"
            style={{ paddingLeft: "150px" }}
          >
            <Checkbox
              iconStyle={{ fill: "#47A1AB", marginRight: "10px" }}
              label={"CSV File"}
              labelStyle={{ fontSize: "13px" }}
              defaultChecked={true}
              ref="cbCSV"
              onCheck={(e, isInputChecked) =>
                this.cbCSVChange(e, isInputChecked)
              }
            />
          </FullRow>
          <FullRow className="no-padding no-margin-bottom mt-20 text-center">
            <button
              type="button"
              onClick={() => this.setState({ showDownloadDialog: false })}
              className="btn btn-default btn-aa-info mr-20"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={this.handleDownload.bind(this)}
              disabled={this.state.disabledBtnDownload}
              className="btn btn-default btn-aa-default"
            >
              Download File
            </button>
          </FullRow>
        </Dialog>
      </div>
    );
  }
}

export default TopLinksClick;



// WEBPACK FOOTER //
// ./src/components/Campaigns/Report/TopLinksClick.jsx